function Privacy() {
  const updated = "This policy was last reviewed in " + new Date().getFullYear() + ".";
  return (
    <main className="ix-page">
      <header className="ix-hero">
        <div className="ix-shell">
          <span className="ix-eyebrow is-gray">Legal</span>
          <h1>Privacy Policy</h1>
        </div>
      </header>

      <section className="ix-section">
        <div className="ix-shell ix-prose">
          <p>
            Intellusion builds intelligent systems for people and teams. We collect
            only what we need to run our products and respond to you, and we aim to be
            clear about what that is. {updated}
          </p>

          <h2>Information we collect</h2>
          <p>
            Information you give us directly, such as your name, email, and the content
            of messages or job applications you send through this site. Basic technical
            information your browser provides, such as device and usage data, used to
            keep the service secure and working.
          </p>

          <h2>How we use your information</h2>
          <p>
            To reply to your enquiries, review applications, operate and improve our
            products, and keep our systems safe. We do not sell your personal data.
          </p>

          <h2>Sharing</h2>
          <p>
            We share personal data only with service providers who help us run the
            business, or where we are required to by law. We ask those providers to
            protect your data and use it only for the purpose we engaged them for.
          </p>

          <h2>Retention and security</h2>
          <p>
            We keep personal data only as long as we need it for the purpose it was
            collected, then delete or anonymise it. We use reasonable technical and
            organisational measures to protect it.
          </p>

          <h2>Your rights</h2>
          <p>
            Depending on where you live, you may have the right to access, correct, or
            delete your personal data, or to object to certain uses. To make a request,
            contact us using the details below.
          </p>

          <h2>Changes</h2>
          <p>
            We may update this policy as our products evolve. Material changes will be
            reflected here with an updated review date.
          </p>

          <h2>Contact</h2>
          <p>
            Questions about privacy? Email us at{" "}
            <a href="mailto:osama@intellusionai.com">osama@intellusionai.com</a>.
          </p>
        </div>
      </section>
    </main>
  );
}

export default Privacy;
